import React from 'react';
import {UserTranslationsConsumer} from 'context/UserTranslationsContext';

export const WithUserTranslations = WrappedComponent => {
  class WithUserTranslations extends React.Component {
    render() {
      return (
          <UserTranslationsConsumer>
            {({userTranslations}) => (
                <WrappedComponent
                    {...this.props}
                    translations={{...this.props.translations, ...userTranslations}}
                />
            )}
          </UserTranslationsConsumer>
      );
    }
  };

  WithUserTranslations.displayName = `WithUserTranslations(${getDisplayName(
      WrappedComponent)})`;

  return WithUserTranslations;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
